import React, { useState } from "react";
import { Box, IconButton, InputAdornment, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useUpdateAccountPasswordMutation } from "../../../store/services/auth/auth.service";
import { useFormik } from "formik";
import { updatePasswordAccountSchema } from "../../Auth/schemas";
import { toast } from "react-toastify";
import { notifyError } from "../../../utils/NotifyError";
import { IError } from "../../../utils/getErrorMessage";
import ButtonComponent from "../../../Components/ButtonComponent";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Security = () => {
	const [showPassword, setShowPassword] = useState(false);
	const [callUpdatePassword, { isLoading }] = useUpdateAccountPasswordMutation();
	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));

	const {
		handleSubmit,
		handleChange,
		errors,
		values: { oldPassword, password, confirmPassword },
		dirty,
		isValid,
		resetForm
	} = useFormik({
		validationSchema: updatePasswordAccountSchema,
		initialValues: {
			oldPassword: "",
			password: "",
			confirmPassword: ""
		},
		onSubmit: values => {
			callUpdatePassword({ oldPassword: values.oldPassword, password: values.confirmPassword }).then(
				({ data, error }) => {
					if (data) {
						toast.success("Password updated successfully.", { autoClose: 3000 });
						resetForm();
					}
					if (error) {
						notifyError(error as IError);
					}
				}
			);
		}
	});
	const handleClickShowPassword = () => setShowPassword(show => !show);

	return (
		<form
			onSubmit={handleSubmit}
			style={{
				width: isSmallerScreen ? "100%" : "55%",
				padding: "10px"
			}}
		>
			<Box mb={2} className={"input_wrapper"}>
				<Typography variant={"subtitle1"} fontWeight={"bold"}>
					Old Password
				</Typography>
				<TextField
					fullWidth
					type={"password"}
					value={oldPassword}
					name={"oldPassword"}
					onChange={handleChange}
					error={!!errors.oldPassword}
					helperText={errors.oldPassword}
				/>
			</Box>
			<Box mb={2} className={"input_wrapper"}>
				<Typography variant={"subtitle1"} fontWeight={"bold"}>
					New Password
				</Typography>
				<TextField
					fullWidth
					type={showPassword ? "text" : "password"}
					value={password}
					name={"password"}
					onChange={handleChange}
					error={!!errors.password}
					helperText={errors.password}
					slotProps={{
						input: {
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										aria-label={showPassword ? "hide password" : "display password"}
										onClick={handleClickShowPassword}
										edge="end"
									>
										{showPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							)
						}
					}}
				/>
			</Box>
			<Box mb={2} className={"input_wrapper"}>
				<Typography variant={"subtitle1"} fontWeight={"bold"}>
					Confirm Password
				</Typography>
				<TextField
					fullWidth
					type={showPassword ? "text" : "password"}
					value={confirmPassword}
					name={"confirmPassword"}
					onChange={handleChange}
					error={!!errors.confirmPassword}
					helperText={errors.confirmPassword}
					slotProps={{
						input: {
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										aria-label={showPassword ? "hide password" : "display password"}
										onClick={handleClickShowPassword}
										edge="end"
									>
										{showPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							)
						}
					}}
				/>
			</Box>
			<Box width={"100%"}>
				<ButtonComponent
					fullWidth
					variant={"contained"}
					type="submit"
					disabled={(dirty && !isValid) || isLoading}
					text={"Update Password"}
					loading={isLoading}
				/>
			</Box>
		</form>
	);
};

export default Security;
